import { eventBus } from "../eventBus"

export const emitImageViewerOpen = (url: string) =>
    eventBus.emit("imageViewerOpen", url)

export const onImageViewerOpen = (handler: (url: string) => void) =>
    eventBus.on("imageViewerOpen", handler)

export const offImageViewerOpen = (handler: (url: string) => void) =>
    eventBus.off("imageViewerOpen", handler)
